var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('div',{staticClass:"p-4"},[_c('LoginForm',{attrs:{"route-from":_vm.routeFrom,"is-modal":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }